import React, { useEffect, useState } from "react";
import { Button, ListGroup, ListGroupItem, Modal } from "react-bootstrap";
import { ListBankAccounts } from "../../containers/Settings/ListBankAccounts";
import { Constants } from "../../libs/Constants";
import { get } from "../../libs/dbFunctions";
export const UserSettings = (props) => {
  const [user, setUser] = useState(null);
  const onCancel = () => {
    props.onCancel();
  };
  //Load user data
  useEffect(() => {
    if (props.object.id) {
      loadUser();
    }
  }, [props.object]);
  const loadUser = async () => {
    try {
      let response = await get(Constants.dbTypes.USER, props.object.id);
      if (response) {
        setUser(response);
      }
    } catch (err) {}
  };
  return (
    <React.Fragment>
      <Modal.Header>
        <Modal.Title>Account Info</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {!user && <>Loading...</>}
        {user && (
          <>
            <ListGroup className="font-size-2 mb-4">
              <ListGroupItem key="dwolla_customer_status">
                Dwolla customer status -{" "}
                <span className="ps-1 text-capitalize">
                  <b>{user.dwolla_customer_status || ""}</b>
                </span>
              </ListGroupItem>
            </ListGroup>
            <ListBankAccounts accounts={user?.accounts} />
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button type="button" variant="outline-cancel" onClick={onCancel}>
          Cancel
        </Button>
      </Modal.Footer>
    </React.Fragment>
  );
};
